import { AOrderProjectModel, AProjectModel } from '@/model';
import { ProjectModel } from '@/model/Admin/ProjectModel';
import Api from './Api';

class _ProjectApi extends Api {
    loadProjects(client_id: number): Promise<any> {
        return this.getHttpClient().get(`project/list/${client_id}`);
    }

    loadProjectTypes(): Promise<any> {
        return this.getHttpClient().get(`/project/type/list`);
    }

    loadProject(id: number): Promise<any> {
        return this.getHttpClient().get(`project/${id}/detail`);
    }

    loadOrderProject(id: number): Promise<any> {
        return this.getHttpClient().get(`project/${id}/order`);
    }

    storeProject(data: AProjectModel): Promise<any> {
        return this.getHttpClient().post(`project/store`, data);
    }

    updateOrderProject(data: AOrderProjectModel): Promise<any> {
        return this.getHttpClient().post(`project/order/update`, data);
    }

    removeProject(project: ProjectModel): Promise<any> {
        return this.getHttpClient().delete(`/project/${project.id}`);
    }

    sendApproveRequest(data: any): Promise<any> {
        return this.getHttpClient().post(`project/send-approve-request`, data);
    }

    approveProject(data: any): Promise<any> {
        return this.getHttpClient().post(`project/approve`, data);
    }

    prolongProject(project_id: number): Promise<any> {
        return this.getHttpClient().post(`project/prolong`, { project_id: project_id });
    }

    projectAddActorToBlacklist(actor_id: number, project_id: number): Promise<any> {
        return this.getHttpClient().post(`/project/blacklist/actor-add`, { actor_id, project_id });
    }

    projectRemoveActorFromBlacklist(actor_id: number, project_id: number): Promise<any> {
        return this.getHttpClient().post(`/project/blacklist/actor-remove`, { actor_id, project_id });
    }

    loadProjectEssentials(): Promise<any> {
        return this.getHttpClient().get(`project/essentials`);
    }

    requestVideo(data: any): Promise<any> {
        return this.getHttpClient().post(`/video/request`, data);
    }
}

export const ProjectApi = new _ProjectApi();
